import { useEffect, useState } from "react";
import { getFleetData } from "../services/services";
import { FleetDataContext } from "./context";

const FleetoProvider = ({ children }) => {
  const [fleetoData, setFleetoData] = useState(null);
  const [fleetoLoading, setFleetoLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchFleetoData = async () => {
    console.log("fleeeeeeto:");
    const Fleeto = await getFleetData({ lang: "el" })
      .then((response) => {
        console.log("fleeeeeeto:", response);
        setFleetoLoading(false);
        return response ?? [];
      })
      .catch((error) => {
        setFleetoLoading(false);
        setError(error);
        return [];
      });
    setFleetoData(Fleeto);
  };

  useEffect(() => {
    const intervalFleeto = setInterval(() => {
      fetchFleetoData();
    }, 1000 * 60 * 5); // 5 minutes

    // clean up
    return () => clearInterval(intervalFleeto);
  }, []);

  useEffect(() => {
    fetchFleetoData();
  }, []);

  return (
    <FleetDataContext.Provider
      value={{ fleetoData, setFleetoData, fleetoLoading, error }}
    >
      {children}
    </FleetDataContext.Provider>
  );
};

export default FleetoProvider;
